import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { TaskConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { TaskService } from './api/task.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class TaskApiModule {
    public static forRoot(configurationFactory: () => TaskConfiguration): ModuleWithProviders<TaskApiModule> {
        return {
            ngModule: TaskApiModule,
            providers: [ { provide: TaskConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: TaskApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('TaskApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
